"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
exports.default = (state = {}, action) => {
    if (action.segments) {
        return Object.assign({}, action.segments);
    }
    return state;
};
exports.getSegment = (state, segmentId) => state[segmentId] || null;
exports.getAllSegments = (state) => {
    if (state) {
        return Object.keys(state).map((segmentId) => exports.getSegment(state, segmentId));
    }
};
exports.getUnselectedSegments = (state) => {
    const compoundSegment = index_1.getEditableCampaignSegment(state);
    const segmentIds = compoundSegment ? compoundSegment.ids : [];
    return exports.getAllSegments(state.segments)
        .filter(({ isArchived }) => !isArchived)
        .filter(({ segmentId }) => !segmentIds.includes(segmentId));
};
